import { gql } from '../../__generated__/gql'

export const HOMEPAGE_PREVIEW_QUERY = gql(`
  query homepagePreview($includeUnpublished: Boolean, $blockId: Int) {
    featuredHomepageBlocks(includeUnpublished: $includeUnpublished, blockId: $blockId) {
      id
      header
      subheader {
        line
        secondLine
        fontSize
      }
      buttonText
      url
      modalTitle
      opacity
      backgroundImage
    }
  }
`)
